// extracted by mini-css-extract-plugin
export default {"free":"ContactPhoto_free__Gx2yV","busy":"ContactPhoto_busy__GKRnA","photo":"ContactPhoto_photo__Z8onf","icon":"ContactPhoto_icon__94ftk","error":"ContactPhoto_error__-yDaD"};